export const BERLIN_TIME_ZONE = 'Europe/Berlin';
